<mat-form-field
  [subscriptSizing]="input.subscriptSizing"
  [appearance]="input.appearance"
>
  @if (input.label | parse: context | async; as label) {
    <mat-label>{{ label }}</mat-label>
  }
  <mat-select
    [formControl]="_formControl"
    [placeholder]="input.placeholder | parse: context | async"
    [disabled]="input.disabled | parse: context | async"
    [required]="input.required"
    [multiple]="input.multiple"
    (blur)="onBlur($event)"
  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="filterCtrl"
        [placeholderLabel]="input.searchPlaceHolder | parse: context | async"
        [noEntriesFoundLabel]="
          input.noEntriesFoundLabel | parse: context | async
        "
      />
    </mat-option>
    @for (option of filteredOptions$ | async; track option) {
      <mat-option [value]="option[input.optionsValueKey || 'value']">
        {{ option[input.optionsLabelKey || 'label'] }}
      </mat-option>
    }
  </mat-select>
  @if (firstFormControlError; as error) {
    <mat-error>
      {{ error.errorMessage | parse: context | async }}
    </mat-error>
  }
</mat-form-field>
